import React from "react";
import * as scss from "./docs-image.scss";

export type ImageProps = {
	/** The path of the image */
	src?: string;
	/** ALT text */
	alt?: string;
};

export function Image(props: ImageProps): JSX.Element {
	const { src, alt } = props;

	return <img src={src} alt={alt} className={scss.image} />;
}
